import {
  Users,
  FileText,
  ShieldCheck,
  Activity,
  BarChart,
  Grid,
  LifeBuoy,
  Heart,
  Check,
  LucideIcon,
} from 'lucide-react';

type IconName =
  | 'users'
  | 'fileText'
  | 'shieldCheck'
  | 'activity'
  | 'bar-chart'
  | 'grid'
  | 'lifebuoy'
  | 'heart'
  | 'check';

interface ImpactCardProps {
  icon: IconName;
  value: string;
  label: string;
}

const ICON_MAP: Record<IconName, LucideIcon> = {
  users: Users,
  fileText: FileText,
  shieldCheck: ShieldCheck,
  activity: Activity,
  'bar-chart': BarChart,
  grid: Grid,
  lifebuoy: LifeBuoy,
  heart: Heart,
  check: Check,
};

export function ImpactCard({ icon, value, label }: ImpactCardProps): React.ReactElement {
  const IconComponent = ICON_MAP[icon];

  return (
    <div className="group bg-card shadow-medium hover:border-primary/30 hover:shadow-strong relative transform cursor-pointer rounded-xl border p-3 transition-all duration-300 hover:-translate-y-1 hover:scale-105">
      <div className="from-primary/5 to-primary/10 absolute inset-0 rounded-xl bg-linear-to-br opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

      <div className="relative z-10">
        <div className="mb-1 flex justify-center">
          <div className="flex h-10 w-10 transform items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:rotate-6">
            <IconComponent className="text-primary group-hover:text-primary/80 h-7 w-7" />
          </div>
        </div>

        <div className="mb-1 text-center">
          <div className="text-foreground text-xl font-bold transition-all duration-300">
            {value}
          </div>
        </div>

        <div className="text-center">
          <div className="text-muted-foreground group-hover:text-foreground text-xs font-medium transition-colors duration-300">
            {label}
          </div>
        </div>
      </div>

      <div className="from-primary/40 to-primary/50 absolute inset-0 -z-10 rounded-2xl bg-linear-to-r opacity-0 blur-xl transition-opacity duration-300 group-hover:opacity-20" />
    </div>
  );
}
